import OverviewRedirect from './OverviewRedirect';

export default OverviewRedirect;
